import array from "lodash/array";
import PropTypes from "prop-types";
import React, { Children, cloneElement, Component } from "react";

class Loader extends Component {
    render() {
        const { children, className, isLoading } = this.props;
        const loaderClass = className ? "spinner-wrapper ".concat(className) : "spinner-wrapper";
        const loader = (
            <div className={loaderClass}>
                <div className="spinner">
                    <span />
                    <span />
                    <span />
                </div>
            </div>
        );

        return isLoading ? loader : array.first(Children.toArray(cloneElement(children)));
    }
}

Loader.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    className: PropTypes.string,
    children: PropTypes.element.isRequired,
};

export default Loader;
